/* eslint-disable no-const-assign */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import { connect } from 'react-redux';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { modalActions } from '../../../Actions';
import { BaseModal } from '../BaseModal';
import { Button } from '@/Components/ui/button';

const AlertModalSecondary = (props) => {
	const { show, toggleSecondaryAlert, data, type = 'alertModal', setCancle = () => {} } = props;
	const {
		rendererType = 'alertModal',
		nextLineMessage = false,
		extraData = {},
	} = data;
	const HEADING = `${data.heading ?? ''}`;

	const handleClose = () => {
		toggleSecondaryAlert(false);
		setCancle(true);
	};

	const handleConfirm = () => {
		if (data?.handleConfirm) {
			data?.handleConfirm();
		}
		toggleSecondaryAlert(false);
	};

	const buttons = () => {
		return (
			<div className='w-full flex gap-2'>
				<Button
					onClick={() => {
						data?.handleCancel?.();
						handleClose?.();
					}}
					variant='outline'
					className='flex-1'
				>
					{!data?.colorReverse && <ClearIcon />}
					{data?.cancelText ?? 'Cancel'}
				</Button>
				<Button
					onClick={handleConfirm}
					variant={!data?.colorReverse && 'destructive'}
					className={`flex-1 ${
						data?.colorReverse ? 'bg-uy-color' : ''
					}`}
					// color={data?.colorReverse ? 'error' : 'success'}
				>
					<CheckIcon />
					{data?.confirmText ?? 'Proceed'}
				</Button>
			</div>
		);
	};

	return (
		<BaseModal
			heading={HEADING || ''}
			height={data?.height ?? 'fit-content'}
			renderBtns={buttons}
			open={show && rendererType === type}
			handleClose={handleClose}
			width={data?.width ?? '24rem'}
		>
			<span
				style={{
					fontSize: '1rem',
					display: 'flex',
					flexDirection: 'column',
					gap: '0.5rem',
					padding: '0.5rem',
				}}
			>
				{data.message}
				{data?.message2 && (
					<span className='text-sm text-gray-500'>
						{data?.message2}
					</span>
				)}
			</span>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.secondaryAlertModal;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleSecondaryAlert: modalActions.toggleSecondaryAlert,
};
export default connect(mapStateToProps, mapDispatchToProps)(AlertModalSecondary);
